import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import AddRegions from "./add-region";
import { RegionsService } from "../../services/regionsService";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import { NotificationManager } from "src/util/notify";
import Loader from "../../control-components/loader/loader";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

function Regions() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [isAddRegion, setAddRegion] = useState(false);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [sort, setSort] = useState([]);
  const [selectedState, setSelectedState] = React.useState({});
  const [regionListing, setRegions] = useState([]);

  useEffect(() => {
    getAllRegions();
  }, []);

  const handleAddRegion = () => {
    setAddRegion(true);
  };

  const handleCloseRegion = () => {
    setAddRegion(false);
  };

  const getAllRegions = async () => {
    setLoading(true);
    await RegionsService.getRegions()
      .then((result) => {
        setRegions(result?.resultData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const pageChange = (event) => {
    let skip = event.page.skip;
    let take = event.page.take;
    setPage(skip);
    setPageSize(take);
  };

  return (
    <div>
      <div className="grid-table  filter-grid">
        <div className=" mt-3">
          <div className="inner-section-edit position-relative text-center">
            <div className="grid-table  filter-grid header-blue">
              <div className=" mt-3">
                {loading && <Loader />}
                <Grid
                  data={orderBy(
                    regionListing.slice(page, pageSize + page),
                    sort
                  ).map((item) => ({
                    ...item,
                    [SELECTED_FIELD]: selectedState[idGetter(item)],
                  }))}
                  checkboxElement
                  style={{
                    height: regionListing.length > 0 ? "100%" : "250px",
                  }}
                  dataItemKey={DATA_ITEM_KEY}
                  selectedField={SELECTED_FIELD}
                  skip={page}
                  take={pageSize}
                  total={regionListing.length}
                  onPageChange={pageChange}
                  pageable={{
                    pageSizes: [10, 20, 30],
                  }}
                  sort={sort}
                  sortable={true}
                  onSortChange={(e) => {
                    setSort(e.sort);
                  }}
                >
                  <GridNoRecords style={{}}></GridNoRecords>
                  {/* <GridColumn filterable={false} field={SELECTED_FIELD} width="100px" /> */}
                  <GridColumn
                    className="cursor-default"
                    field="regionName"
                    title="Region Name"
                  />
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isAddRegion && <AddRegions onClose={handleCloseRegion} />}
    </div>
  );
}
export default Regions;
